var currentId = null, items = [], i;
var changeHeight;

/**
 * 
 * @param {String} id 
 */
function addToRemoveFromCompare(id) {
    //alert(window.location.href.toString());
    const urlSearchParams = new URLSearchParams(window.location.search);
    console.log(urlSearchParams);
    var urlPath = window.location.search;
    urlPath = urlPath.replace("?", "");
    urlPath = urlPath.replace(/&/g,"-");
    urlPath = urlPath.replace(/=/g,"|");
    // alert(urlPath);

    //MUDAR - para & no controller
    
    // alert(window.location.pathname);

    var finaldestination;
    finaldestination = window.location.protocol + '//' + window.location.host + "/entity-comparison/disciplina/" + id + "?destination=" + window.location.pathname + "&filters=" + urlPath;
    
    // alert(finaldestination);
    window.location.href = finaldestination;
}

function runAddCode(id, el) {
    addToRemoveFromCompare(id);
}

function myModule_ajax_load() {
    jQuery("#ajax-target").load("/node/get/ajax/11");
  }

  

(function($) {
    var url = window.location.origin;

    $(document).ready(function(){
        /**
         * COMPARISON TABLE 
         */

         var cicle = $(".cicle").text();

         switch(cicle) {
            case "1.º Ciclo":
              $('body').addClass("firstcycle");
              break;
            case "2.º Ciclo":
                $('body').addClass("secondcycle");
              break;
            case "3.º Ciclo":
                $('body').addClass("thirdcycle");
          }

          var level = $(".level").text();

          if (level == "Ensino Secundário") {
            $('body').addClass("highschool");
          }

          var disc = $(".subject-name").text();

          if (disc == "Português Língua não materna") {
            $('body').removeClass("firstcycle");
            $('body').removeClass("secondcycle");
            $('body').removeClass("thirdcycle");
            $('body').removeClass("highschool");
            $('body').addClass("ptlnm");
          }

          $(".resource-text .type:contains(Artigo)").parent().parent().addClass("article");
          $(".resource-text .type:contains(Projeto)").parent().parent().addClass("project");
          $(".resource-text .type:contains(Vídeo)").parent().parent().addClass("vid");
          $(".resource-text .type:contains(Recursos)").parent().parent().addClass("res");
          $(".resource-text .type:contains(Práticas)").parent().parent().addClass("practices");
          $(".resource-text .type:contains(Orientações)").parent().parent().addClass("orientations");
          $(".resource-text .type:contains(Conferência)").parent().parent().addClass("conference");
        //   if(type.text() == "Artigo / Brochura / Publicação") {
        //     $(this).parent().parent().addClass("article");
        //   } 

        $(".path-recursos-educativos .view-filters #edit-search-api-fulltext").attr("placeholder", "O que procura?");

        $('.block-facet-blockdisciplinas .select2-search__field').attr("placeholder", "Adicionar disciplina");
        $('.block-facet-blocktitle .select2-selection__placeholder').text('O que procura?');
        $('select2-results__message').text('Introduza 1 ou mais caracteres');

         $('.path-organizacao-curricular .view-subjects table tbody tr td label input').on('click', function(e) {
            e.preventDefault();
            var reload_element = $(this);
            var post_url = '/organizacao-curricular';
            var post_data = reload_element.serialize();

            $.ajax({
                type: 'POST',
                url: post_url, 
                data: post_data,
                success: function(msg) {
                    $(reload_element).fadeOut(800, function(){
                        reload_element.html(msg).fadeIn().delay(2000);
                    });
                }
            });
         });

         $('#block-resourcesmobiletop').on('click', function() {
            $('.view-filters').toggleClass('visible');
            
            $('body').toggleClass('no-scroll');
            $('#featured').toggleClass('visible');
            $('#block-resourcesmobiletop').toggleClass('mobile-top-active');
        });

        $('#block-mobilefilterbutton').on('click', function() {
            $('#facets').toggleClass('facets-mobile-open');
            $('#block-mobilefilterbutton').toggleClass('mobile-filter-open');
        });

        $('.field--name-link-for-entity-comparison-disciplina div:contains("+") a').addClass('not-selected');

        $('.field--name-link-for-entity-comparison-disciplina div:contains("-") a').addClass('selected');
            
        $('.to-top-button').on('click', function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
         });

        $('.scroll-button-forward').on('click', function() {
            var pos = $('.path-compare main #content #block-curriculo-content').scrollLeft() + 535;
            $('.path-compare main #content #block-curriculo-content').scrollLeft(pos);
        });

        $('.scroll-button-back').on('click', function() {
            var pos2 = $('.path-compare main #content #block-curriculo-content').scrollLeft() - 535;

            $('.path-compare main #content #block-curriculo-content').scrollLeft(pos2);
        });

        $('.action i').on('click', function() {
            $('#block-subjectcomparisonblock').toggleClass('minimized-comparison-bar');
        });

        if ($('#block-disciplina-2').find('.disabled').length != 0) {
            $('#block-disciplina2').removeClass('green');
            $('#block-disciplina2 a').addClass('disabled');
        }
        

         if ($('#block-subjectcomparisonblock').find('.filled').length == 0) {
            $('#block-subjectcomparisonblock').addClass('not-active');
         }

         $('.ui-autocomplete').on('click', function() { 
            var e = jQuery.Event("keypress");
            e.which = 13; //choose the one you want
            e.keyCode = 13;
            
            $('#facets>div>div #block-formularioexpostosubjectspage-1 .js-form-item input').trigger(e);
            var event = jQuery.Event( "submit" );
            $( "#views-exposed-form-subjects-page-1" ).trigger( event );
         });

         if($('.block-subject-comparison-block').find('.filled').length < 2) {
            $('.compare a button').addClass('disabled'); 
            $('.compare a').addClass('no-click'); 
            $('#block-disciplina2 a').addClass('disabled');
         }

         if ($('.path-compare main #content #block-curriculo-content>table>tbody>tr:first-child>td').length < 3) {
             $('.scroll-button-forward').addClass('not-active');
             $('.scroll-button-back').addClass('not-active');
         }

        //  if ($('.path-compare').length > 0 && $('#comparison-table>tbody>.odd>td').hasClass('empty')) {
        //     window.location = '/organizacao-curricular';
        //  } 

         

        if ($('.path-compare').length > 0) {
            changeHeight = function () {
                $('#comparison-table > tbody > tr').each(function () {
                    $(this).height($(this).height()-20);
                    $(this).children('td').find('.field').height($(this).height()-20);
                });
            }

            $('#comparison-table > thead').find('.actions .pin').on('click', function() {

                // if ($('#comparison-table tr').find('th.sticky, td.sticky').length <= 0) {
                    $('#comparison-table').find('> thead, > tbody').find('> tr > th:first-child, > tr > td:first-child').each(function() {
                        $(this).toggleClass('sticky');
                    });
                // }
            });

            // $('#block-curriculo-content').freezeTable();
            // $('#comparison-table').DataTable({
            //     fixedHeader: true,
            //     scrollY: 500,
            //     scrollX: true,
            //     scrollCollapse: true,
            //     fixedColumns: {
            //         leftColumns: 1
            //     }
            // });

            // $(window).on('scroll', function() {
            //     if($(window).scrollTop() > 169) {
            //         var height = '-'+$(window).scrollTop()+'px';
            //         $('html').css('position', 'fixed').css('top', height).css('width', '100%');
            //         // $('#comparison-table thead').addClass('fix');
            //         // $('#content').addClass('table-header-fixed');
            //     } else {
            //         // $('#comparison-table thead').removeClass('fix');
            //         // $('#content').removeClass('table-header-fixed');
            //     }
            // });
         }

        function generateChecks() {
            if($("#block-curriculo-content .view-id-subjects .view-content table tbody tr").length > 0) {
                if ($('body #compare-checkbox-container input').length < 1) {
                    $('body #compare-checkbox-container').each(function() {
                        if ($(this).attr('data-node-id') !== '') {
                            var check = '<input type="checkbox" name="compare-add" value="' + $(this).attr('data-node-id') + '" onclick="runAddCode(' + $(this).attr('data-node-id') + ', ' + $(this).parent().parent().index() + ')"' + (items.includes($(this).attr('data-node-id')) ? 'checked' : '') + '>';
                            $(this).append(check);
                            $(this).find('input').on('click', function() {
                                $('body #compare-checkbox-container input').attr('disabled', true);
                            });
                        }
                    });
                    
                }
            }
        }

        if ($('body #compare-checkbox-container').length > 0) {
            
            $('body #compare-checkbox-container input').on('click', function() {
                $('body #compare-checkbox-container input').attr('disabled', true);
            });

            jQuery.get(window.location.protocol + '//' + window.location.host + '/get-entity-c-session?_format=json', function (data) {
                items = data.ent_comp;

                console.log(data)

                // i = setInterval(generateChecks, 100);
            });
        }

        if ($('body #compare-checkbox-container input:checked').length > 0) {
            $('#block-disciplina-2').addClass('green');
            $('#block-disciplina2').addClass('green');
        } else {
            $('#block-disciplina-2').removeClass('green');
            $('#block-disciplina2').removeClass('green');
        }

        if ($('.path-recursos').length > 0) {
            var element = $('#edit-field-associated-subjects')[0].cloneNode(true);
            element.style.display = 'none';
            $('#edit-field-associated-subjects')[0].id = 'edit-field-associated-subjects-placeholder';
            $('#edit-field-associated-subjects-placeholder').removeAttr('data-drupal-selector');
            $('#edit-field-associated-subjects-placeholder').removeAttr('name');
            $('#edit-field-associated-subjects-placeholder').parent().append(element);

            var config = { attributes: true, childList: true, subtree: true };
            var inputValue;
            var callback = function () {
                $('#ui-id-2 li').each(function () {
                    console.log($(this).find('a').text());
                    $(this).on('click', function () {
                        $('#edit-field-associated-subjects').val($('#edit-field-associated-subjects-placeholder').val());
                        $('#edit-field-associated-subjects-placeholder').val($(this).find('a').text());
                        $('#edit-submit-resources').trigger('click');
                    })
                });
            }
            var observer = new MutationObserver(callback);
            observer.observe($('#ui-id-2')[0], config);
        }

        if ($('#facets select').length > 0) {
            $('#facets select').on('click', function() {
                $(this).addClass('green');
            });

            $(document).on('click', function(e) {
                if ($('#facets select.green').length > 0) {
                    $('#facets select.green').each(function() {
                        if (!$(this).is(e.target)) {
                            $(this).removeClass('green');
                        }
                    });
                }
            });
        }

        $('#hamb-menu-button').on('click', function() {
            // $(this).toggleClass('active');
            $('#site-header').toggleClass('menu-active');
            $('#site-footer').toggleClass('menu-active');
            $('body').toggleClass('menu-active');
        });
    });

    /**     **\
     * TABS! *
     */

     // Get relevant elements and collections
    $('.operationalization').each(function(e) {
        var tabbed = this.querySelector('.tabbed');
        var tablist = tabbed.querySelector('ul');
        var tabs = tablist.querySelectorAll('a');
        var panels = tabbed.querySelectorAll('[id^="section"]');
        
        // The tab switching function
        var switchTab = function(oldTab, newTab) {
            newTab.focus();
            // Make the active tab focusable by the user (Tab key)
            newTab.removeAttribute('tabindex');
            // Set the selected state
            newTab.setAttribute('aria-selected', 'true');
            oldTab.removeAttribute('aria-selected');
            oldTab.setAttribute('tabindex', '-1');
            // Get the indices of the new and old tabs to find the correct
            // tab panels to show and hide
            var index = Array.prototype.indexOf.call(tabs, newTab);
            var oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
            panels[oldIndex].hidden = true;
            panels[index].hidden = false;
            // changeHeight();
        }
        
        // Add the tablist role to the first <ul> in the .tabbed container
        tablist.setAttribute('role', 'tablist');
        
        // Add semantics are remove user focusability for each tab
        Array.prototype.forEach.call(tabs, function(tab, i) {
            tab.setAttribute('role', 'tab');
            tab.setAttribute('id', 'tab' + (i + 1));
            tab.setAttribute('tabindex', '-1');
            tab.parentNode.setAttribute('role', 'presentation');
            
            // Handle clicking of tabs for mouse users
            tab.addEventListener('click', function(e) {
            e.preventDefault();
            var currentTab = tablist.querySelector('[aria-selected]');
            if (e.currentTarget !== currentTab) {
                switchTab(currentTab, e.currentTarget);
            }
            });
            
            // Handle keydown events for keyboard users
            tab.addEventListener('keydown', function(e) {
            // Get the index of the current tab in the tabs node list
            var index = Array.prototype.indexOf.call(tabs, e.currentTarget);
            // Work out which key the user is pressing and
            // Calculate the new tab's index where appropriate
            var dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;
            if (dir !== null) {
                e.preventDefault();
                // If the down key is pressed, move focus to the open panel,
                // otherwise switch to the adjacent tab
                dir === 'down' ? panels[i].focus() : tabs[dir] ? switchTab(e.currentTarget, tabs[dir]) : void 0;
            }
            });
        });
        
        // Add tab panel semantics and hide them all
        Array.prototype.forEach.call(panels, function(panel, i) {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('tabindex', '-1');
            var id = panel.getAttribute('id');
            panel.setAttribute('aria-labelledby', tabs[i].id);
            panel.hidden = true; 
        });
        
        // Initially activate the first tab and reveal the first tab panel
        tabs[0].removeAttribute('tabindex');
        tabs[0].setAttribute('aria-selected', 'true');
        panels[0].hidden = false;
    });
}(jQuery));

var getParams = function (url) {
	var params = {};
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};